import React from 'react'
import Linkify from 'react-linkify'
import { PPHyperlink } from './PPHyperLink'

export const PPLinkify = (props: any) => {
  return (
    <Linkify
      componentDecorator={(decoratedHref: string, decoratedText: string, key: number) => {
        return (
          <PPHyperlink target="_blank" rel="noreferrer" href={decoratedHref} key={key}>
            {decoratedText}
          </PPHyperlink>
        )
      }}
    >
      {props.children}
    </Linkify>
  )
}
